import type { FieldName } from './menuItemFinder.type';

export const NAMES_OF_SEARCH_FIELDS: Record<'first' | 'second', FieldName> = {
  first: 'first-searcher',
  second: 'second-searcher',
} as const;
